import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const FellowsAttendingWeeklyTraining= () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Fellows attending weekly training (%)" />
    </Box>
  );
};
